@if (SearchData && (AdvancedSearchConfig == null || !AdvancedSearchConfig.Enabled || (AdvancedSearchConfig.Enabled &&
!AdvancedSearchConfig.Open))) {
<div [ngStyle]="{'text-align': OptionsAlignment}">
    @if (DynamicCount) {
    <mat-form-field matTooltip="Change the amount of rows displayed.">
        <mat-label>Row Count</mat-label>
        <input type="number" matInput placeholder="Row Count" #DynaCount name="DynaCount"
            [formControl]="DynaCountValidator" [(ngModel)]="DisplayCount" (change)="dynamicCountChanged($event)">
        @if (DynaCountValidator.errors && DynaCountValidator.hasError('invalid')) {
        <mat-error>
            Invalid Count
        </mat-error>
        }
    </mat-form-field>
    }
    @if (Search) {
    <mat-form-field [ngClass]="SearchData.Class">
        <mat-label>{{SearchData.Placeholder}}</mat-label>
        <input matInput placeholder="{{ SearchData.Placeholder }}" #input [formControl]="searchTerm"
            (keyup.enter)="searchText()">
        @if (SearchData.Required && searchTerm.errors && searchTerm.hasError('invalid')) {
        <mat-error>
            {{ SearchData.Error }}
        </mat-error>
        }
    </mat-form-field>
    }
    @if (Search) {
    <button mat-raised-button type="button" (click)="searchText()">
        <i class="material-icons">
            search
        </i>
    </button>
    }
    @if (Search) {
    <button mat-raised-button type="button" (click)="reset()">
        <i class="material-icons">
            clear
        </i>
    </button>
    }

    @if (Search) {
    @if (JobNumberExactMatch){
    <mat-checkbox [(ngModel)]="isExactMatch" (change)="onExactMatchChange(isExactMatch)">
        Exact Job Number Match</mat-checkbox>
    }
    }
    @if (Add === true) {
    <button mat-raised-button type="button" (click)="add();">
        <i class="material-icons">
            add
        </i>
        @if (addButtonText) {
        <span style="margin-left:5px">{{ addButtonText }}</span>
        }
    </button>
    }
    @if (TableActions != null) {
    <span>
        @for (action of TableActions; track action) {
        <span>
            @if (action.Toggle !== true && action.Selected == null) {
            <button mat-raised-button type="button" matTooltip="{{ action.Tooltip }}"
                (click)="action.Callback($event, action);">
                @if (action['Icon']) {
                <i class="material-icons">
                    {{ action["Icon"] }}
                </i>
                }
                {{ action["Text"] != null ? action["Text"] : "" }}
            </button>
            } @else if(action.Selected === true && selection.selected.length > 0) {
            <button mat-raised-button type="button" matTooltip="{{ action.Tooltip }}"
                (click)="action.Callback($event, action);">
                @if (action['Icon']) {
                <i class="material-icons">
                    {{ action["Icon"] }}
                </i>
                }
                {{ action["Text"] != null ? action["Text"] : "" }}
            </button>
            }
        </span>
        }
    </span>
    }
    @if (AdvancedSearchConfig != null && AdvancedSearchConfig.Enabled && !AdvancedSearchConfig.Open) {
    <span class="hyperlink btn-margin"
        (click)="AdvancedSearchConfig.Callback(); AdvancedSearchConfig.Open = true;">Advanced</span>
    }
</div>
}
@if (!(SearchData && Search && (AdvancedSearchConfig == null || !AdvancedSearchConfig.Enabled ||
(AdvancedSearchConfig.Enabled && !AdvancedSearchConfig.Open)))) {
<br />
}
@if (!loading) {
<div class="upper-line">
    @if (Heading != null) {
    <p class="text-left bold">{{ Heading }}</p>
    }
    @if (CheckOptions != null) {
    <section [ngClass]="radioButtonStyle" [style]="'float:'+radioButtonFloat+';'">
        <mat-radio-group aria-label="Select an option" [(ngModel)]="checkOptionValue"
            [ngModelOptions]="{standalone: true}" (change)="OptionChanged($event)" [name]="'CheckOptionGroup'">
            @for (c of CheckOptions; track c) {
            <mat-radio-button class="checkbox-margins" [value]="c.Value">
                {{c.Text}}
            </mat-radio-button>
            }
        </mat-radio-group>
    </section>
    }

    @if (AdditionalCheckOptions != null && checkOptionValue === CheckOptions[0].Value) {
    <section [ngClass]="radioButtonStyle" [style]="'float:'+radioButtonFloat+';'">
        <mat-radio-group aria-label="Select additional options" [(ngModel)]="additionalCheckOptionValue"
            [ngModelOptions]="{standalone: true}" (change)="AdditionalOptionChanged($event)"
            [name]="'AdditionalCheckOptionGroup'">
            @for (option of AdditionalCheckOptions; track option) {
            <mat-radio-button class="checkbox-margins" [value]="option.Value">
                {{option.Text}}
            </mat-radio-button>
            }
        </mat-radio-group>
    </section>
    }

    @if (Heading === "Claim Batches" && checkOptionValue === CheckOptions[1].Value) {
    <div class="input-container">
        <app-month-date-picker [defaultDate]="displayDate ? displayDate : null" (monthChosen)="onMonthChange($event)">
        </app-month-date-picker>
    </div>
    }

    @for (action of TableActions; track action) {
    <span class="pull-right">
        @if (action.Toggle === true) {
        <mat-slide-toggle class="padded-btn" [(ngModel)]="action.Value"
            [disabled]="!action.Validator ? false : !action.Validator(action)"
            (change)="action.Callback($event, action);">{{action.Text }}
        </mat-slide-toggle>
        }
    </span>
    }
</div>
}
@if (loading) {
<mat-spinner class="mainSpinner"></mat-spinner>
}
@if (!loading && Data && Data.length == 0) {
<div class="fullwidth">
    <br />
    <br />
    <br />
    <p>No results were found.</p>
    <br />
</div>
}
@if (Data && Data.length > 0) {
<table [hidden]="loading" #matTable multiTemplateDataRows mat-table matSort class="table-styling mat-elevation-z8"
    [dataSource]="dataSource" (matSortChange)="sortData($event)"
    [style]="RowGap!=null?'border-spacing: 0 '+RowGap+'px;':null">
    @if(sideTagConfig!=null){
    <ng-container matColumnDef="status">
        @if (Selectable && !SelectionHighlight && Multiple && SelectPage&& SelectAll) {
        <th mat-header-cell *matHeaderCellDef class="sortHeader align-left">
            <mat-checkbox (change)="$event ? allToggled() : null" [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()" matTooltip="Select All Rows">
            </mat-checkbox>
        </th>
        }@else {
        <th mat-header-cell *matHeaderCellDef></th>
        }
        <td class="side-label" mat-cell *matCellDef="let element">
            @if(sideTagConfig.ColourMapping[element[sideTagConfig.PropertyID]]!=null){
            <div class="color-band"
                [style]="'background-color:'+sideTagConfig.ColourMapping[element[sideTagConfig.PropertyID]]"
                [matTooltip]="sideTagConfig.tooltipTextFn != null ? sideTagConfig.tooltipTextFn(element) : ''"
                matTooltipClass="my-cust">
                &nbsp;
            </div>
            }@else {
            <div class="color-band" [style]="'background-color:'+sideTagConfig.ColourMapping['default']"
                [matTooltip]="sideTagConfig.tooltipTextFn != null ? sideTagConfig.tooltipTextFn(element) : ''"
                matTooltipClass="custom-tooltip">
                &nbsp;
            </div>
            }

        </td>

    </ng-container>
    }@else if (Selectable && !SelectionHighlight && Multiple && SelectPage&& SelectAll) {
    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="sortHeader align-left">
            <mat-checkbox (change)="$event ? allToggled() : null" [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()" matTooltip="Select All Rows">
            </mat-checkbox>
        </th>
    </ng-container>
    }


    @if (Selectable && !SelectionHighlight) {
    <ng-container matColumnDef="check">
        <th mat-header-cell *matHeaderCellDef class="sortHeader align-left">
            @if (Multiple) {
            @if (SelectPage){
            <mat-checkbox (change)="$event ? pageToggled() : null" [checked]="selection.hasValue() && isPageSelected()"
                matTooltip="Select All Rows in Page">
            </mat-checkbox>
            }@else if (SelectAll) {
            <mat-checkbox (change)="$event ? allToggled() : null" [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()" matTooltip="Select All Rows">
            </mat-checkbox>
            }
            }
        </th>
        <td class="no-border" mat-cell *matCellDef="let row">
            @if (Multiple) {
            <mat-checkbox (click)="$event.stopPropagation()" (change)="checkBoxChecked(row)"
                [checked]="selection.isSelected(row) || isSelectedCheck(row)"
                [disabled]="SelectDisabledFn != null && SelectDisabledFn(row)">
            </mat-checkbox>
            }
            @if (!Multiple) {
            <mat-radio-button (click)="$event.stopPropagation();" (change)="checkBoxChecked(row)"
                [checked]="selection.isSelected(row) || isSelectedCheck(row)"
                [disabled]="SelectDisabledFn != null && SelectDisabledFn(row)">
            </mat-radio-button>
            }
        </td>
    </ng-container>
    }
    @for (item of Headers; track item; let i = $index) {
    <div>
        @if (!item.Hidden) {
        <ng-container [style.width]="item.Width != null ? (item.Width + 'px') : '200px'">
            <ng-container matColumnDef="{{ item.ID }}" (click)="$event.stopPropagation();">
                @if (item.Sortable) {
                <div>
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="{{ item.Sort }}"
                        class="{{ item.Align != null && item.Align == 'left' ? 'leftHeader' : 'sortHeader' }} align-left"
                        [ngClass]="{'ellipsis' : item.Ellipsis === true }">
                        {{ item.Text }}
                    </th>
                </div>
                }
                @if (!item.Sortable) {
                <div>
                    <th mat-header-cell *matHeaderCellDef
                        class="{{ item.Align != null && item.Align == 'left' ? 'leftHeader' : 'sortHeader' }} align-left"
                        [ngClass]="{'ellipsis' : item.Ellipsis === true }">
                        {{ item.Text }}
                    </th>
                </div>
                }
                <!-- && item.TooltipValidator(item, element) -->
                <!-- TODO: -->
                <td class="no-border" mat-cell *matCellDef="let element" [enabled]="item.Tooltip === true"
                    tooltipDirective>

                    <ng-template #tooltipTemplate>
                        <ng-container
                            *ngTemplateOutlet="item.TooltipTemplate; context: { $implicit: 'World', elem: element }">
                        </ng-container>
                    </ng-template>
                    <!-- <div enabled="item.Tooltip === true" tooltipDirective>
                    </div> -->

                    @if (item.ProgressBar === true) {
                    <div [matTooltip]="item.MatToolTip ? item.MatToolTip(element) : ''" class="progress-div">
                        <mat-progress-bar mode="buffer" [color]="'warn'"
                            [value]="item.Wrapper(element, element[item.Sort] )">
                        </mat-progress-bar>
                        {{ item.Wrapper(element, element[item.Sort] ) }}
                    </div>
                    }
                    @if (!item.ProgressBar) {
                    <div [matTooltip]="item.MatToolTip ? item.MatToolTip(element) : ''"
                        [ngClass]="{'ellipsis' : item.Ellipsis === true }">
                        @if (item.HTML != null) {
                        <div>
                            @if (item.Wrapper == null) {
                            <span [innerHTML]="item.HTML"
                                class="{{ item.HTMLMod != null ? item.HTMLMod(element) : '' }}"></span>
                            }
                            @if (item.Wrapper != null) {
                            <span>
                                <span class="html-text">{{ item.Wrapper(element, element[item.Sort]) }}</span>
                                <span [innerHTML]="item.HTML"
                                    class="{{ item.HTMLMod != null ? item.HTMLMod(element) : '' }}"></span>
                            </span>
                            }
                        </div>
                        }
                        @if (item.HTMLModifier != null) {
                        <span (click)="innerHTMLClicked(item, element)" [innerHTML]="item.HTMLModifier(element)"></span>
                        }
                        <!-- <span *ngIf="item.HTMLVal != null" [innerHTML]="item.HTMLVal(element)" class="{{ item.HTMLMod != null ? item.HTMLMod(element) : '' }}"></span> -->
                        @if (item.IsIconLink) {
                        <span class="pointer material-icons" (click)="item.Click(element);">{{ item.Icon }}</span>
                        }
                        @if (item.Link != null && item.Wrapper==null) {
                        <span class="hyperlink" (click)="item.Link(element);$event.stopPropagation();">{{
                            element[item.Sort]}}</span>
                        }
                        @if (item.Link != null && item.Wrapper!=null && !isImage(item.Type) && !isDate(item.Type) &&
                        !item.IsIconLink && !(item.Type == null)) {
                        <span class="hyperlink" (click)="item.Link(element);$event.stopPropagation();">{{
                            item.Wrapper(element, element[item.Sort]) }}</span>
                        }
                        @if (item.Wrapper != null && item.Link == null && !isImage(item.Type) && !isDate(item.Type) &&
                        !item.IsIconLink && !(item.Type == null)) {
                        <span [style]="item.WrapperStyle ? item.WrapperStyle(element) : ''">
                            {{ item.Wrapper(element, element[item.Sort] ) }}
                        </span>
                        }
                        @if (item.Wrapper != null && item.Link == null && isDate(item.Type)) {
                        <span>
                            {{ (item.Wrapper(element[item.Sort]) | date:"yyyy-MM-dd H:mm") }}
                        </span>
                        }
                        @if (item.Wrapper == null && item.Link == null) {
                        <span>
                            @if (isArray(item.Type);) {
                            <span>
                                @for (e of element[item.Sort]; track e) {
                                <p>{{ item.ObjectKey == null ? e : e[item.ObjectKey] }}</p>
                                }
                            </span>
                            }
                            @if(isObject(item.Type);) {
                            <span>
                                <p>{{ element[item.Sort] == null || element[item.Sort][item.ObjectKey]==null ? "-":
                                    element[item.Sort][item.ObjectKey] }}</p>
                            </span>
                            }
                            @if (isDate(item.Type);) {
                            <span>
                                @if (ParseDate && element['Wrapper'] == null) {
                                <span>{{ element[item.Sort] != null ? (element[item.Sort] | formatDateTime |
                                    date:"yyyy-MM-dd H:mm") : item.NullText != null ? item.NullText : "N/A" }}</span>
                                }
                                @if (!ParseDate && element['Wrapper'] == null) {
                                <span>{{ element[item.Sort] != null ? (element[item.Sort] | date:"yyyy-MM-dd H:mm") :
                                    item.NullText != null ? item.NullText : "N/A" }}</span>
                                }
                            </span>
                            }
                            @if (isBoolean(item.Type);) {
                            <span>
                                {{ element[item.Sort] === true ? "Yes" : "No" }}
                            </span>
                            }
                            @if (isNumber(item.Type);) {
                            <span>
                                {{ element[item.Sort] == null || element[item.Sort] == "" ? "0" : element[item.Sort] }}
                            </span>
                            }
                            @if (isString(item.Type);) {
                            <span>
                                {{ element[item.Sort] == null || element[item.Sort] == "" ? "-" : element[item.Sort] }}
                            </span>
                            }
                        </span>
                        }
                        @if (isImage(item.Type) && item.Wrapper != null) {
                        <div>
                            <img width="25" src="{{ 'assets/images/' + item.Wrapper(element,element[item.Sort]) }}">
                        </div>
                        }
                    </div>
                    }
                </td>
            </ng-container>
        </ng-container>
        }
    </div>
    }
    @if (Actions && Actions.length > 0) {
    <ng-container matColumnDef="actions">
        <th mat-cell *matHeaderCellDef class="sortHeader align-left">
            Actions
        </th>
        <td mat-cell *matCellDef="let element">
            @if (element['showActions'] == true) {
            <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation();">
                <mat-icon>more_vert</mat-icon>
            </button>
            }
            <mat-menu #menu="matMenu">
                @for (action of Actions; track action) {
                <div>
                    @if (action['Validator'] == null || action['Validator'](element);) {
                    <button mat-menu-item (click)="action.Caller(element);$event.preventDefault();">
                        <mat-icon>{{ action.IconWrapper != null ? action.IconWrapper(element) : action.Icon
                            }}</mat-icon>
                        <span>{{ action.TextWrapper != null ? action.TextWrapper(element) : action.Text }}</span>
                    </button>
                    }
                </div>
                }
            </mat-menu>
        </td>
    </ng-container>
    }
    @if (ExpansionConfig != null && ExpansionConfig.Template != null) {
    <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="columnHeaders.length">
            <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                @if (ExpansionConfig.HtmlTemplate == null) {
                @if(ExpansionConfig.Template != null && ExpansionConfig.Template(element)!=null &&
                ExpansionConfig.Template(element)["spinner"]==true){
                <div class="spinner-container">
                    <mat-spinner [diameter]="40"></mat-spinner>
                </div>
                }@else {
                <div class="" [innerHTML]="ExpansionConfig.Template != null ? ExpansionConfig.Template(element) : null">

                </div>
                }

                }
                <ng-container #dropDownTemplate
                    *ngTemplateOutlet="ExpansionConfig.HtmlTemplate; context: { $implicit: element}">
                </ng-container>

            </div>
        </td>
    </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="columnHeaders" class="header-row"></tr>
    <tr class="data-row" mat-row *matRowDef="let row; columns: columnHeaders;"
        [class.example-expanded-row]="expandedElement === row" [class.important-state]="row.HasImportantState"
        [class.error-state]="row.HasErrorState" [class.ok-state]="row.HasOKState"
        [class.neutral-state]="row.HasNeutralState" [class.grey-state]="row.HasBaseState"
        [class.highlighted]="!!row.Checked && SelectionHighlight" [class.button-type-row]="ButtonRows"
        (click)="rowClicked(row)">
    </tr>
    @if (ExpansionConfig != null && ExpansionConfig.Template != null) {
    <div>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </div>
    }
</table>
}
@if (DataCount!=null && DataCount > 0) {
<div [hidden]="loading">
    <mat-paginator [length]="DataCount" [pageSizeOptions]="PageSizeOptions==null? [DisplayCount]:PageSizeOptions"
        [pageSize]="DisplayCount" showFirstLastButtons [pageIndex]="PageIndex" (page)="getServerData($event);">
    </mat-paginator>
</div>
}